import { useRouter } from "next/router";
import { Gameday } from "../../models/Gameday";
import { FullSeason } from "../../models/Season";
import { SeasonTeam } from "../../models/Team";
import { Option, Select } from "../common/Select";
import { translateScheduleLabel } from "@/helper/scheduleLabel";
import { getSeasonString } from "../../helper/util";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import { Headline } from "@/components/common/Headline";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

interface GamescheduleHeader {
  selectedSeason: FullSeason;
  selectedTeamQuery: string;
  selectedLeagueQuery: "bundesliga" | "pokal";
  selectedGamedayQuery: string;
  seasons: FullSeason[];
  teams: SeasonTeam[];
  gamedays: Gameday[];
  isMobile?: boolean;
  title?: string;
}
export function GamescheduleHeader({
  teams,
  seasons,
  gamedays,
  selectedGamedayQuery,
  selectedLeagueQuery,
  selectedSeason,
  selectedTeamQuery,
  isMobile = false,
  title,
}: GamescheduleHeader) {
  const { push, locale } = useRouter();
  const selectedSeasonQuery = getSeasonString(selectedSeason);
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      {isMobile && (
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex justify-between items-center container"
        >
          <Headline className="">{title}</Headline>

          {isOpen ? (
            <FiChevronUp className="mb-4" />
          ) : (
            <FiChevronDown className="mb-4" />
          )}
        </button>
      )}
      <div
        className={`flex-col px-4 lg:px-0 mb-4 lg:flex-row ${
          isOpen || !isMobile ? "flex" : "hidden"
        }`}
      >
        <Select
          value={selectedTeamQuery}
          onChange={(e) =>
            push(
              `/${selectedLeagueQuery}/gameschedule/${selectedSeasonQuery}/${selectedGamedayQuery}/${e}`
            )
          }
          className="white lg:ml-auto lg:border-[1px]"
        >
          <>
            <Option value="all">{t("All_Teams")}</Option>
            {teams.map((t) => (
              <Option key={t.id} value={t.id}>
                {t.name}
              </Option>
            ))}
          </>
        </Select>
        <Select
          value={selectedLeagueQuery}
          onChange={(e) =>
            push(`/${e}/gameschedule/${selectedSeasonQuery}/1/all`)
          }
          className="white lg:hidden"
        >
          {selectedSeason.bundesliga.status !== "Inactive" && (
            <Option value="bundesliga">Bundesliga</Option>
          )}
          {selectedSeason.pokal.status !== "Inactive" && (
            <Option value="pokal">Pokal</Option>
          )}
        </Select>
        <Select
          value={selectedSeasonQuery}
          onChange={(e) =>
            push(`/${selectedLeagueQuery}/gameschedule/${e}/1/all`)
          }
          className="white lg:border-[1px] lg:ml-4"
        >
          {seasons.map((s) => (
            <Option
              key={s.id}
              value={`${s.startYear}-${s.endYear}`}
            >{`${s.startYear}-${s.endYear}`}</Option>
          ))}
        </Select>

        {selectedLeagueQuery === "bundesliga" && (
          <Select
            value={selectedGamedayQuery}
            onChange={(e) =>
              push(
                `/${selectedLeagueQuery}/gameschedule/${selectedSeasonQuery}/${e}/${selectedTeamQuery}`
              )
            }
            className="white lg:ml-4 lg:border-[1px]"
          >
            {gamedays.map((g) => (
              <Option key={g.id} value={g.index.toString()}>
                {translateScheduleLabel(g.name, locale)}
              </Option>
            ))}
          </Select>
        )}
      </div>
    </>
  );
}
